import { useContext } from "react";
import { Navigate } from "react-router-dom";
import { UserContext } from "../context/UserContext";

export default function ProtectedRoute({ children, role, roles, permission, permissions }) {
  const { user, ready } = useContext(UserContext);
  if (!ready) return (
    <div style={{ padding: 24 }} aria-busy="true" aria-live="polite">Lade …</div>
  );
  if (!user) return <Navigate to="/login" />;
  const userRoles = Array.isArray(user.roles) ? user.roles : [];
  const userPerms = Array.isArray(user.permissions) ? user.permissions : [];
  if (Array.isArray(roles) && roles.length > 0) {
    const ok = roles.some(r => userRoles.includes(r));
    if (!ok) return <Navigate to="/dashboard" />;
  } else if (role) {
    if (!userRoles.includes(role)) return <Navigate to="/dashboard" />;
  }
  if (Array.isArray(permissions) && permissions.length > 0) {
    const okp = permissions.some(p => userPerms.includes(p));
    if (!okp) return <Navigate to="/dashboard" />;
  } else if (permission) {
    if (!userPerms.includes(permission)) return <Navigate to="/dashboard" />;
  }
  // Hier könnten später komplexere Berechtigungen je Rolle ergänzt werden
  return children;
}
